<template>
    <div>

        <kgr-form-scaffold
            :pending="loading"
            hide-mandatory-fields-hint
            :with-back-button="false"
            @primaryBtnClicked="save"
        >
            <br />
            <div class="kgr-inputGroup">
                <div class="kgr-inputGroup__label">
                    {{ $t('Stichtag') }}
                </div>
                <kgr-date-picker
                    v-model="referenceDate"
                    class="kgr-float--left"
                />
            </div>
            <br style="clear:both;" />
            <br />
            <kgr-table
                :is-data-table="false"
                style="width: 100%"
                not-striped
            >
                <thead>
                    <tr class="kgr-table__row">
                        <th class="kgr-table__cell kgr-table__cell--headline"></th>
                        <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Art'"></th>
                        <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Gültig von'"></th>
                        <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Gültig bis'"></th>
                        <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Beantragt am'"></th>
                        <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Bestätigt am'"></th>
                        <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Vorgelegt am'"></th>
                        <th class="kgr-table__cell kgr-table__cell--headline" v-t="'Aktion'"></th>
                    </tr>
                </thead>
                <tbody
                    v-for="(handicapType, indexA) in handicapTypes"
                    :key="indexA"
                >
                    <tr
                        v-for="(handicap, indexC) in handicapsByType[handicapType]"
                        :key="indexC"
                        :class="{'bottom-border': indexC + 1 === handicapsByType[handicapType].length, striped: isStriped(handicapType, handicap), deleted: handicap?.deleted, 'current': handicap !== null && isCurrent(handicap), 'in-past': handicap !== null && isPast(handicap), 'in-future': handicap !== null && isFuture(handicap)}"
                        class="kgr-table__row"
                    >
                        <td
                            v-if="indexC === 0"
                            class="kgr-table__cell"
                            :rowspan="handicapsByType[handicapType].length + 1"
                        >
                            <kgr-icon
                                v-show="handicapsByType[handicapType].filter(h => h !== null && !h.deleted).length > 0"
                                icon-class="check"
                                circle
                                style="cursor:initial;"
                                :style="'background-color: ' + (isChecked(handicapType) ? 'green' : 'lightgray')"
                            />
                        </td>
                        <td
                            v-if="indexC === 0"
                            class="kgr-table__cell"
                            :rowspan="handicapsByType[handicapType].length + 1"
                        >
                            <kgr-input-group
                                :error-message="error.messageForField('handicaps.' + handicapType)"
                            >
                                <span v-html="translateHandicapType(handicapType)">    </span>
                            </kgr-input-group>
                        </td>
                        <td class="kgr-table__cell adapt">

                            <kgr-input-group
                                :error-message="error.messageForField('handicaps[' + indexC + '][start]')"
                            >
                                <kgr-date-picker
                                    v-if="edits.includes(handicap)"
                                    v-model="handicap.start" />
                                <span v-else>
                                    {{ handicap?.start }}
                                </span>
                            </kgr-input-group>
                        </td>
                        <td class="kgr-table__cell adapt">
                            <kgr-input-group
                                :error-message="error.messageForField('handicaps[' + indexC + '][end]')"
                            >
                                <kgr-date-picker
                                    v-if="edits.includes(handicap)"
                                    v-model="handicap.end" />
                                <span v-else>
                                    {{ handicap?.end }}
                                </span>
                            </kgr-input-group>
                        </td>
                        <td class="kgr-table__cell adapt">
                            <kgr-input-group
                                :error-message="error.messageForField('handicaps[' + indexC + '][requestedAt]')"
                            >
                                <kgr-date-picker
                                    v-if="edits.includes(handicap)"
                                    v-model="handicap.requestedAt" />
                                <span v-else>{{ handicap?.requestedAt }}</span>
                            </kgr-input-group>
                        </td>
                        <td class="kgr-table__cell adapt">
                            <kgr-input-group
                                :error-message="error.messageForField('handicaps[' + indexC + '][confirmedAt]')"
                            >
                                <kgr-date-picker
                                    v-if="edits.includes(handicap)"
                                    v-model="handicap.confirmedAt" />
                                <span v-else>
                                    {{ handicap?.confirmedAt }}
                                </span>
                            </kgr-input-group>
                        </td>
                        <td class="kgr-table__cell adapt">
                            <kgr-input-group
                                :error-message="error.messageForField('handicaps[' + indexC + '][presentedAt]')"
                            >
                                <kgr-date-picker
                                    v-if="edits.includes(handicap)"
                                    v-model="handicap.presentedAt" />
                                <span v-else>
                                    {{ handicap?.presentedAt }}
                                </span>
                            </kgr-input-group>
                        </td>
                        <td
                            class="kgr-table__cell kgr-table__cell--actions"
                        >
                            <kgr-icon-add
                                v-if="indexC === 0"
                                @click="add(handicapType)"
                            />
                            <template
                                v-if="handicap !== null"
                            >
                                <kgr-icon-edit @click="edit(handicap)" />
                                <kgr-icon-delete
                                    v-if="!handicap.deleted"
                                    @click="remove(handicap)"
                                />
                                <kgr-icon-reset
                                    v-else
                                    @click="undoRemove(handicap)"
                                />
                            </template>
                        </td>
                    </tr>
                </tbody>
            </kgr-table>
        </kgr-form-scaffold>
    </div>
</template>

<script>
import ChildHandicap from '../../js/dto/ChildHandicap.js';
import Date from '../../js/date/Date.js';
import DateObjectPicker from '../../components/common/form/picker/DateObjectPicker.vue';
import Error from '../../js/model/Error.js';
import FormScaffold from '../../components/common/form/FormScaffold.vue';
import Icon from '../../components/common/icon/Icon.vue';
import IconAdd from '../../components/common/icon/IconAdd.vue';
import IconDelete from '../../components/common/icon/IconDelete.vue';
import IconEdit from '../../components/common/icon/IconEdit.vue';
import IconReset from '../../components/common/icon/IconReset.vue';
import InputGroup from '../../components/common/form/InputGroup.vue';
import axios from 'axios';

export default {
    components: {
        'kgr-date-picker': DateObjectPicker,
        'kgr-icon-delete': IconDelete,
        'kgr-icon-edit': IconEdit,
        'kgr-icon-add': IconAdd,
        'kgr-form-scaffold': FormScaffold,
        'kgr-icon-reset': IconReset,
        'kgr-input-group': InputGroup,
        'kgr-icon': Icon,
    },
    props: {
        childId: {
            type: Number,
            required: true,
        },
    },
    data() {
        return {
            referenceDate: Date.today(),
            loading: true,
            edits: [],
            handicaps: [],
            error: new Error(),
            handicapTypes: [
                'handicapped',
                'handicapApproved',
                'integrationHelpPhysicalHandicap',
                'integrationHelpMentalHandicap',
                'integrationHelpOncomingHandicap',
            ],
        }
    },
    computed: {
        handicapsByType() {
            return {
                handicapped: this.getSortedHandicapsByType('handicapped') ?? [null],
                handicapApproved: this.getSortedHandicapsByType('handicapApproved') ?? [null],
                integrationHelpPhysicalHandicap: this.getSortedHandicapsByType('integrationHelpPhysicalHandicap') ?? [null],
                integrationHelpMentalHandicap: this.getSortedHandicapsByType('integrationHelpMentalHandicap') ?? [null],
                integrationHelpOncomingHandicap: this.getSortedHandicapsByType('integrationHelpOncomingHandicap') ?? [null],
            }
        }
    },
    created() {
        this.load();
    },
    methods: {
        isCurrent(handicap) {
            const referenceDate = this.referenceDate ?? Date.today();

            return (handicap?.start === null || handicap.start.isBeforeOrEqual(referenceDate)) &&
                (handicap?.end === null || handicap.end.isAfterOrEqual(referenceDate))
            ;
        },
        isPast(handicap) {
            const referenceDate = this.referenceDate ?? Date.today();

            return handicap?.end !== null && handicap.end.isBefore(referenceDate);
        },

        isFuture(handicap) {
            const referenceDate = this.referenceDate ?? Date.today();

            return handicap?.start !== null && handicap.start.isAfter(referenceDate);
        },

        isStriped(handicapType, handicap) {
            const mainRowOdd = this.handicapTypes.indexOf(handicapType) % 2 === 1;
            if(this.handicapsByType[handicapType].indexOf(handicap) === 0) {
                return !mainRowOdd;
            }

            const subRowOdd = this.handicapsByType[handicapType].indexOf(handicap) %2 === 1;

            return mainRowOdd ? subRowOdd : !subRowOdd;
        },
        isChecked(handicapType) {
            return this.getCurrentHandicapByTypeAndReferenceDate(handicapType) !== null;
        },
        add(handicapType) {
            const handicap = new ChildHandicap();
            handicap.handicapType = handicapType;
            this.handicaps.push(handicap)
            this.edits.push(handicap);
        },
        edit(handicap) {
            this.edits.push(handicap);
        },
        undoRemove(handicap) {
            handicap.deleted = false;
        },
        remove(handicap) {
            handicap.deleted = true;
            if(handicap.id === null) {
                this.handicaps = this.handicaps.filter(h => h !== handicap);
            }
        },
        getCurrentHandicapByTypeAndReferenceDate(handicapType) {

            const referenceDate = this.referenceDate ?? Date.today();

            return this.handicaps.find(h => h.handicapType === handicapType
                && (h.start === null || h.start.isBeforeOrEqual(referenceDate))
                && (h.end === null || h.end.isAfterOrEqual(referenceDate))
                && !h.deleted
            ) ?? null;

        },
        getSortedHandicapsByType(handicapType) {
            const handicaps = this.handicaps
                .filter(h => h.handicapType === handicapType)
                .sort((a, b) => {
                    if (a.start === null) return -1;
                    if (b.start === null) return 1;
                    return a.start.isBefore(b.start) ? 1 : -1;
                });
            if(handicaps.length === 0) {
                return [null];
            }
            return handicaps;
        },

        load(){
            this.loading = true;
            this.error = new Error();
            axios.get(`/children/${this.childId}/handicaps`)
                .then(response => {
                    this.handicaps = response.data.data.map(data => ChildHandicap.fromData(data));
                })
                .catch(() => this.$notify.error('error.loadingData'))
                .finally(() => this.loading = false);

        },
        translateHandicapType(handicapType) {
            switch (handicapType) {
                case 'handicapped':
                    return this.$t('Behinderung');
                case 'handicapApproved':
                    return this.$t('Behinderung anerkannt (Integration Typ A)');
                case 'integrationHelpPhysicalHandicap':
                    return this.$t('Kind erhält Eingliederungshilfe wegen körperlicher Behinderung (Integration Typ B)');
                case 'integrationHelpMentalHandicap':
                    return this.$t('Kind erhält Eingliederungshilfe wegen geistiger Behinderung (Integration Typ B)');
                case 'integrationHelpOncomingHandicap':
                    return this.$t('Kind erhält Eingliederungshilfe wegen drohender oder seelischer Behinderung (Integration Typ B)');
                default:
                    return handicapType;
            }
        },
        save() {
            axios.put(`/children/${this.childId}/handicaps`,
                {
                    handicaps: this.handicaps.map(h => h.serialize()),
                }
            )
                .then(() => {
                    this.$notify.success('saveChanges.success');
                    this.edits = [];
                    this.load();
                })
                .catch(error => {
                    this.$notify.error('saveChanges.error');
                    this.error = Error.fromResponse(error.response);
                });
        }
    },
}
</script>

<style scoped lang="scss" rel="stylesheet/scss">
.striped {
    background-color: var(--kgr-table-striped-background-color);
}
tr.deleted td.adapt {
    background-color: #f6a9a9;
    text-decoration: line-through;
}
tr.current td.adapt span {
    font-weight: var(--kgr-font-weight-bold);
}
tr.in-past td.adapt {
    opacity: 0.5;
}
tr.in-future td.adapt {
    font-weight: var(--kgr-font-weight-normal);
}
tr td {
    border-bottom: none;
}
tr.bottom-border {
    border-bottom: 1px solid var(--kgr-table-striped-background-color);
}
tr.bottom-border.striped {
    border-bottom: 1px solid #fff;
    border-collapse: inherit;

}
</style>
